import { Type } from '@sinclair/typebox';
export const BearerType = Type.RegEx(/^Bearer .+$/);
export const AuthorizationSchema = Type.Object({
    authorization: BearerType,
});
export const FortnoxAuthorizationSchema = Type.Object({
    authorization: BearerType,
    fortnoxauthorization: BearerType,
});
